import React from 'react'
import { ApplicationSummarySection } from '../../api/Types'
import DynamicCallToAction from '../common/DynamicCallToAction'
import LandingPageSectionWrapper from '../common/LandingPageSectionWrapper'

type Props = ApplicationSummarySection

const LandingPageApplicationSummary: React.FC<Props> = ({ title, summary, style, cta }) => {
  return (
    <>
      <LandingPageSectionWrapper cssNamespace='application-summary-section' style={style}>
        <div className='application-summary-section-container'>
          <div className='application-summary-section-left-container'>
            <h2 className='title'>{title}</h2>
            {cta && <DynamicCallToAction cta={cta} />}
          </div>
          <p className='text'>{summary}</p>
        </div>
      </LandingPageSectionWrapper>
    </>
  )
}

export default LandingPageApplicationSummary
